// src/styles/theme.js
import { createTheme } from "@mui/material/styles";

export const getTheme = (darkMode) =>
  createTheme({
    palette: {
      mode: darkMode ? "dark" : "light",
      primary: {
        main: darkMode ? "#90caf9" : "#1976d2",
      },
      background: {
        default: darkMode ? "#121212" : "#ffffff",
        paper: darkMode ? "#1e1e1e" : "#ffffff",
      },
      text: {
        primary: darkMode ? "#ffffff" : "#000000",
      },
    },
    typography: {
      fontFamily: "'Source Sans Pro', sans-serif",
    },
    shadows: [
      "none",
      "0px 1px 3px rgba(0,0,0,0.12), 0px 1px 2px rgba(0,0,0,0.24)",
      "0px 3px 6px rgba(0,0,0,0.16), 0px 3px 6px rgba(0,0,0,0.23)",
      "0px 10px 20px rgba(0,0,0,0.19), 0px 6px 6px rgba(0,0,0,0.23)",
      "0px 15px 25px rgba(0,0,0,0.2), 0px 10px 10px rgba(0,0,0,0.22)",
      "0px 20px 40px rgba(0,0,0,0.22), 0px 15px 12px rgba(0,0,0,0.24)",
      "0px 24px 48px rgba(0,0,0,0.25), 0px 16px 16px rgba(0,0,0,0.25)",
      "0px 28px 56px rgba(0,0,0,0.26), 0px 18px 18px rgba(0,0,0,0.26)",
      "0px 32px 64px rgba(0,0,0,0.28), 0px 20px 20px rgba(0,0,0,0.28)",
      "0px 36px 72px rgba(0,0,0,0.29), 0px 22px 22px rgba(0,0,0,0.29)",
      "0px 40px 80px rgba(0,0,0,0.3), 0px 24px 24px rgba(0,0,0,0.3)",
      "0px 44px 88px rgba(0,0,0,0.31), 0px 26px 26px rgba(0,0,0,0.31)",
      "0px 48px 96px rgba(0,0,0,0.32), 0px 28px 28px rgba(0,0,0,0.32)",
      "0px 52px 104px rgba(0,0,0,0.33), 0px 30px 30px rgba(0,0,0,0.33)",
      "0px 56px 112px rgba(0,0,0,0.34), 0px 32px 32px rgba(0,0,0,0.34)",
      "0px 60px 120px rgba(0,0,0,0.35), 0px 34px 34px rgba(0,0,0,0.35)",
      "0px 64px 128px rgba(0,0,0,0.36), 0px 36px 36px rgba(0,0,0,0.36)",
      "0px 68px 136px rgba(0,0,0,0.37), 0px 38px 38px rgba(0,0,0,0.37)",
      "0px 72px 144px rgba(0,0,0,0.38), 0px 40px 40px rgba(0,0,0,0.38)",
      "0px 76px 152px rgba(0,0,0,0.39), 0px 42px 42px rgba(0,0,0,0.39)",
      "0px 80px 160px rgba(0,0,0,0.4), 0px 44px 44px rgba(0,0,0,0.4)",
      "0px 84px 168px rgba(0,0,0,0.41), 0px 46px 46px rgba(0,0,0,0.41)",
      "0px 88px 176px rgba(0,0,0,0.42), 0px 48px 48px rgba(0,0,0,0.42)",
      "0px 92px 184px rgba(0,0,0,0.43), 0px 50px 50px rgba(0,0,0,0.43)",
      "0px 96px 192px rgba(0,0,0,0.44), 0px 52px 52px rgba(0,0,0,0.44)",
    ],
    components: {
      MuiPaper: {
        styleOverrides: {
          root: {
            boxShadow: darkMode
              ? "0px 4px 10px rgba(255, 255, 255, 0.15)"
              : "0px 4px 10px rgba(0, 0, 0, 0.15)",
          },
        },
      },
      MuiAppBar: {
        styleOverrides: {
          root: {
            boxShadow: darkMode
              ? "0px 2px 5px rgba(255, 255, 255, 0.2)"
              : "0px 2px 5px rgba(0, 0, 0, 0.2)",
          },
        },
      },
      MuiCard: {
        styleOverrides: {
          root: {
            boxShadow: darkMode
              ? "0px 3px 6px rgba(255, 255, 255, 0.2)"
              : "0px 3px 6px rgba(0, 0, 0, 0.2)",
          },
        },
      },
    },
  });
